var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconCameraOn = function SvgIconCameraOn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    transform: "translate(-209.000000, -737.000000) translate(209.527988, 737.763994)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.472,
    height: 52.472,
    rx: 26.236
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.186,
    transform: "translate(-209.000000, -737.000000) translate(209.527988, 737.763994) translate(14.211170, 19.677005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.05 2.186L16.398 7.652 24.05 13.118z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.398,
    height: 15.304,
    rx: 2.186
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconCameraOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-camera-on.8e3b1fcc9d2f2df9cc8b7480eb26291c.svg";